/**
 * Check if JWT token is expired or invalid
 * @param {string} token - JWT token
 * @returns {boolean} - true if expired or invalid, false otherwise
 */
export const isTokenExpired = (token) => {
    if (!token) return true;
    
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiry = payload.exp;
        const now = Math.floor(Date.now() / 1000);
        
        return expiry < now;
    } catch (e) {
        console.error('Invalid token format:', e);
        return true;
    }
};

/**
 * Get token from localStorage
 * @returns {string|null} - JWT token or null
 */
export const getToken = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user?.token || null;
    } catch (e) {
        return null;
    }
};

/**
 * Logout user and redirect to login
 */
export const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    window.location.href = '/login';
};

/**
 * Check token and logout if expired or invalid
 */
export const checkTokenAndLogout = () => {
    const token = getToken();
    
    if (token && isTokenExpired(token)) {
        console.warn('Token expired, logging out...');
        handleLogout();
    }
};
